export const formatDate = (date: Date) => {
  return `${date.toLocaleDateString('sk')} / ${date.toLocaleTimeString('sk', {
    hour: '2-digit',
    minute: '2-digit',
  })}`;
};
